import { Link } from '@tanstack/react-router';
import {
  BlocksIcon,
  BoxesIcon,
  ChevronUpIcon,
  FilterIcon,
  LightbulbIcon,
  MergeIcon,
  SparklesIcon,
  TagIcon,
} from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const FEATURES = [
  {
    name: 'Merge feature requests',
    description: 'Merge multiple feature requests into a single request',
    Icon: MergeIcon,
  },
  {
    name: 'AI',
    description: 'Suggest features to auto-merge, comments moderation, etc.',
    Icon: SparklesIcon,
  },
  {
    name: 'Request tags',
    description: 'Add tags to requests',
    Icon: TagIcon,
  },
  {
    name: 'Advanced filters',
    description: 'Filter requests by tags, status, priority, and more',
    Icon: FilterIcon,
  },
  {
    name: "Request's upvotes management",
    description: 'View and manage upvotes for requests',
    Icon: ChevronUpIcon,
  },
  {
    name: 'Native iOS and Android SDK',
    description: 'Request and manage requests on your mobile device',
    Icon: BoxesIcon,
  },
  {
    name: 'Integrations',
    description: 'Jira, Linear, Slack and more',
    Icon: BlocksIcon,
  },
  {
    name: 'Suggest a feature',
    description: `We're always looking for new ideas and feedback. If you have a feature you'd like to see, please let us know.`,
    link: '/feature-request',
    Icon: LightbulbIcon,
    className: 'bg-background',
  },
];

export const FeaturesRoadmap = () => {
  return (
    <div>
      <div className="mt-6 grid gap-6 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
        {FEATURES.map((feature) => {
          const WrapperComponent = feature.link ? Link : 'div';

          return (
            <WrapperComponent to={feature.link} key={feature.name}>
              <Card
                className={cn(
                  'group min-h-40 relative inset-shadow-2xs inset-shadow-orange-500/10 hover:inset-shadow-orange-500/20',
                  feature.className,
                )}
              >
                {feature.Icon && (
                  <div className="absolute top-3 right-3 transition-all group-hover:scale-105 group-hover:brightness-125 duration-500">
                    <feature.Icon className="text-muted z-0 " size={64} />
                  </div>
                )}
                <CardHeader className="z-1">
                  <CardTitle className="text-xl font-medium">{feature.name}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription>{feature.description}</CardDescription>
                </CardContent>
              </Card>
            </WrapperComponent>
          );
        })}
      </div>
    </div>
  );
};
